import styled from '@emotion/styled';

export const FlexContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 9rem;
	min-width: 15rem;

	${(props) =>
		props.disabled &&
		`
			div {
				:nth-of-type(1) {
					> div {
						border-top-right-radius: 0;
						border-bottom-right-radius: 0;
					
						body[dir='rtl'] & {
							border-radius: var(--small-border-radius);
							border-top-left-radius: 0;
							border-bottom-left-radius: 0;
						}
					}
				}
				:nth-of-type(2) {
					> div {
						border-top-left-radius: 0;
						border-bottom-left-radius: 0;
						border-left: none;
					
						body[dir='rtl'] & {
							border-radius: var(--small-border-radius);
							border-top-right-radius: 0;
							border-bottom-right-radius: 0;
							border-right: none !important;
							border-left: 1px solid var(--border-color);
						}
					}
				}
			}
		`}

	.enumSelect > .currency {
		height: 100%;

		> div.enumselect-label {
			padding: 0.85rem 1.15rem;
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			border-left: none;

			body[dir='rtl'] & {
				border-radius: var(--small-border-radius);
				border-right: none !important;
				border-left: 1px solid var(--border-color);
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
				padding: 1.11rem;
			}
		}
	}

	input {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		height: 100%;

		body[dir='rtl'] & {
			border-radius: 0 var(--small-border-radius) var(--small-border-radius) 0;
		}
	}
`;

export const InputContainer = styled.div`
	width: 100%;
	padding: 0;
	font-size: var(--paragraph3-font-size);
	border-radius: var(--small-border-radius);
	margin-bottom: ${({ errorMessage }) => (errorMessage ? 'var(--margin-3)' : '')};
`;
